import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '../../utils/lib/utils';

const Section = React.forwardRef(({ children, className, ...props }, ref) => {
  return (
    <section
      ref={ref}
      className={cn('py-8 md:py-12', className)}
      {...props}
    >
      {children}
    </section>
  );
});

Section.displayName = 'Section';

Section.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export { Section }; 